import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';

export function withSubject<T>(subject: Subject<T>) {
	return {
		setValue: (value: T): void => {
			if (value) {
				subject.next(value);
			}
		},
		valueChanges: subject.pipe(map((v: T) => ({ ...v, pageNumber: 0 }))),
	};
}
